// src/models/accounting/journalEntryModel.js

/**
 * Crea un encabezado de asiento contable.
 */
export const createJournalEntryHeader = (data = {}) => ({
  id: data.id || '',
  entryNumber: data.entryNumber || '',
  date: data.date || new Date().toISOString().split('T')[0],
  concept: data.concept || '',
  referenceType: data.referenceType || '',
  referenceId: data.referenceId || '',
  isManual: data.isManual !== undefined ? data.isManual : true,
  isActive: data.isActive !== undefined ? data.isActive : true,
  createdAt: data.createdAt || new Date().toISOString(),
  updatedAt: data.updatedAt || new Date().toISOString(),
  createdBy: data.createdBy || '',
});

/**
 * Crea una línea de asiento contable (apunte).
 */
export const createJournalLine = (data = {}) => ({
  id: data.id || '',
  journalEntryId: data.journalEntryId || '',
  accountCode: data.accountCode || '',
  accountName: data.accountName || '',
  description: data.description || '',
  debit: typeof data.debit === 'number' ? data.debit : 0,
  credit: typeof data.credit === 'number' ? data.credit : 0,
});

/**
 * Valida la partida doble: DEBE === HABER
 * @throws {Error} Si no cuadra
 */
export const validateDoubleEntry = (lines) => {
  const totalDebit = lines.reduce((sum, line) => sum + (parseFloat(line.debit) || 0), 0);
  const totalCredit = lines.reduce((sum, line) => sum + (parseFloat(line.credit) || 0), 0);

  if (Math.abs(totalDebit - totalCredit) > 0.001) {
    throw new Error(
      `Partida doble no cuadra: Debe (${totalDebit.toFixed(2)}) ≠ Haber (${totalCredit.toFixed(2)})`
    );
  }
  return true;
};

// Cuentas por defecto para automatizaciones
export const DEFAULT_ACCOUNTS = {
  CLIENTES: '430000',
  PROVEEDORES: '410000',
  BANCOS: '572000',
  CAJA: '570000',
  INGRESOS_VENTAS: '710000',
  GASTOS_COMPRAS: '610000',
  IVA_SOPORTADO: '472000',
  IVA_REPERCUTIDO: '477000',
};